import React from "react";
import breathfree from "../assets/articale/7.jpg";
import cross from "../assets/cross.webp";

const BreatheFreely = () => {
  return (
    <div>
      <h2 className="text-3xl font-bold text-[#303030] mb-6">
        {
          "This Mucus Cleaner Has Helped Thousands of People Get Rid of Stuck Mucus & Breathe Freely"
        }
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={breathfree}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p>
          {"And I’m confident that"}{" "}
          <span className="font-bold"> {"it’s going to help you too."}</span>
        </p>
        <p>
          <span className="  font-bold"> {"Just imagine…"}</span>
        </p>
        <div className="bg-[#e2f4f9] p-4">
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"No more coughing, wheezing, and shortness of breath."}
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"No more fatigue, frustration, weakness, and dizziness."}
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0">
              <img src={cross} alt="" className="h-8 w-8" draggable="false" />
            </div>
            <p className="text-[#303030] font-bold">
              {"No more lung and respiratory diseases."}
            </p>
          </div>
        </div>
        <p>
          {"That’s all possible with "}{" "}
          <span className="  font-bold">
            {" "}
            {"Herbal Tea Therapy’s “Breathe.”"}
          </span>
        </p>
        <p>{"And the Best Part?"}</p>
        <p>
          {"It only takes a couple of minutes a day to notice a difference."}
        </p>
        <p>
          {" Simply drop "}{" "}
          <span className="  font-bold"> {" “Breathe” "} </span>
          {"down your throat 2–3 times a day."}
        </p>
        <p>
          {"It will enter your lungs, literally "}{" "}
          <span className="font-bold"> {"target the mucus, "} </span>
          {
            "liquefy it, and expel it, along with all the dangerous chemicals and pollutants, solving the root cause of all your problems, and giving you back healthy, strong lungs and clear breath."
          }
        </p>
      </div>
    </div>
  );
};

export default BreatheFreely;
